import { put, takeLatest } from 'redux-saga/effects';
import { UnlinkLicense } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/UnlinkLicense/' + pk, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const responseResult = yield response.text();


        if (responseResult === Message.LicenseUnlinked) {
            yield put(UnlinkLicense.creators.unlinkLicenseSuccess({ isUnlinked: responseResult }));
        }
        else if (responseResult === Message.LicenseNotUnlinked) {
            yield put(UnlinkLicense.creators.unlinkLicenseFailed("Impossibile bloccare la licenza selezionata."));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio è un errore, rimuovo [ERR] all'inizio
            yield put(UnlinkLicense.creators.unlinkLicenseFailed(responseResult.substring(5)));
        }
        else yield put(UnlinkLicense.creators.unlinkLicenseFailed(responseResult));

    } catch (e) {
        yield put(UnlinkLicense.creators.unlinkLicenseFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(UnlinkLicense.types.UNLINK_LICENSE_REQUEST, runAction);
}